export const editTransform = data => {
    const { newGroup, groupId, group, newCollectionPoint, collectionPointId, collectionPoint, contractorId, ...rest } = data;
    const transformedData = { ...rest };

    if (newGroup === 'true') {
        group.contractorId = contractorId;
        transformedData.group = group;
    } else {
        transformedData.groupId = groupId;
    }

    if (newCollectionPoint === 'true') {
        collectionPoint.contractorId = contractorId;
        transformedData.collectionPoint = collectionPoint;
    } else {
        transformedData.collectionPointId = collectionPointId;
    }

    return transformedData;
};
